import React, { useState, useEffect } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
// import { CSVLink } from "react-csv";
// const { SearchBar } = Search;

import { Form, Row, Col } from "react-bootstrap";

// Import Service
import RegsugarService from "../../services/regsugar.service";
import TimeregService from "../../services/timereg.service";
import authService from "../../services/auth.service";

// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";

moment.locale("th");

//Import Loading
// import Spinner from "react-bootstrap/Spinner";
import LoadingAlert from "../../components/LoadingAlert";
const { ExportCSVButton } = CSVExport;

// Import CSS
import "./regsugarcane.css";

function Regsugarcanelist() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [timeregList, setTimeregList] = useState([]);
  const [timeregSelect, setTimeregSelect] = useState(0);

  const user = authService.getCurrentUser();

  const handleTimeregChange = (e) => {
    setTimeregSelect(e.target.value);
    getData(user.user.user_reg, e.target.value);
  };
  const getTimeRegList = () => {
    TimeregService.getTimereglist(user.user.user_reg)
      .then((response) => {
        setTimeregList(response.data.data);
      })
      .catch((err) => {
        console.log("fetch timereg List Error :" + err);
      });
  };

  useEffect(() => {
    getTimeRegList();
  }, []);

  const getData = (user_reg, timereg_id) => {
    setLoading(true);
    RegsugarService.getRegsugarlist(user_reg, timereg_id)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const ActionsEdit = (row) => {
  //   if (row.row.approve_status == "อนุมัติ") {
  //     return <>-</>;
  //   } else {
  //     return (
  //       <>
  //         <i
  //           className="bi bi-pencil custom-icon-table"
  //           onClick={() => clickEdit(row.row)}
  //         ></i>
  //         <i
  //           className="bi bi-upload custom-icon-table"
  //           style={{ color: "green" }}
  //           onClick={() => clickUpload(row.row)}
  //         ></i>
  //         <i
  //           className="bi bi-trash custom-icon-table"
  //           style={{ color: "red" }}
  //           onClick={() => clickDelete(row.row)}
  //         ></i>
  //       </>
  //     );
  //   }
  // };

  // const actionsEdittFormatter = (cell, row) => {
  //   return <ActionsEdit row={row} />;
  // };

  const columns = [
    {
      text: "regsugar_id",
      dataField: "regsugar_id",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
      csvExport: false,
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "farmer_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        // wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    // {
    //   text: "สร้างโดย",
    //   dataField: "user_create",
    //   sort: true,
    //   editable: false,
    //   headerStyle: () => {
    //     return { textAlign: "center", width: "10%" };
    //   },
    //   style: {
    //     // wordBreak: "break-word",
    //   },
    //   filter: textFilter({ placeholder: "ค้นหา" }),
    // },
    {
      text: "ชาวไร่",
      dataField: "status",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "อนุมัติ",
      dataField: "approve_status",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "อนุมัติโดย",
      dataField: "approver_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "รหัสเกษตร",
      dataField: "farmer_card_id",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "วันที่เริ่ม",
      dataField: "start_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      formatter: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      searchable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "วันที่สิ้นสุด",
      dataField: "end_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      formatter: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "ข้อความ",
      dataField: "comment",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
    },
    // {
    //   text: "แก้ไข",
    //   dataField: "edit",
    //   isDummyField: true,
    //   editable: false,
    //   formatter: actionsEdittFormatter,
    //   headerStyle: () => {
    //     return { textAlign: "center", width: "15%" };
    //   },
    //   style: {
    //     // wordBreak: "break-word",
    //     textAlign: "center",
    //   },
    // },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  // if (loading) return <Spinner animation="border" variant="primary" />;
  if (error) return `Error :${error}`;

  return (
    <div>
      {loading ? <LoadingAlert /> : ""}

      <ToolkitProvider
        bootstrap4
        keyField="regsugar_id"
        data={data}
        columns={columns}
        search
        exportCSV={{
          fileName: "ข้อมูลการจดทะเบียนชาวไร่.csv", // "ข้อมูลสมาชิก_" + {cell} + ".csv",
          separator: ",",
          ignoreHeader: false,
          noAutoBOM: false,
          blobType: "text/plain;charset=utf-8",
          onlyExportFiltered: true,
          exportAll: false,
        }}
      >
        {(prop) => (
          <React.Fragment>
            <Row>
              <Col md={8}>
                <ExportCSVButton
                  {...prop.csvProps}
                  style={{
                    padding: ".375rem .75rem",
                    fontSize: "1rem",
                    // float: "right",
                  }}
                >
                  <i className="bi bi-download"></i>
                </ExportCSVButton>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Select
                    name="approve_status"
                    value={timeregSelect}
                    onChange={handleTimeregChange}
                  >
                    <option value="0">เลือกรอบที่จดทะเบียน</option>
                    {timeregList.map((a) => (
                      <option key={a.timereg_id} value={a.timereg_id}>
                        {a.timereg_desc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <hr />
            <BootstrapTable
              pagination={pagination}
              {...prop.baseProps}
              filter={filterFactory()}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
}

export default Regsugarcanelist;
